// TODO: remove the references to theme and use styled-system directly instead.
export { defaultTheme as theme, withOpacity } from 'styled-system';
